import { useState, useEffect } from 'react';

/**
 * Shows git commit from /build-info.json (written by scripts/write-build-info.js).
 * Compare this string on localhost vs Vercel — they should match after a deploy.
 */
export default function BuildFingerprint() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL || ''}/build-info.json`)
      .then(r => (r.ok ? r.json() : null))
      .then(setInfo)
      .catch(() => setInfo(null));
  }, []);

  if (!info?.short) return null;

  return (
    <div
      title={info.commit || ''}
      style={{
        position: 'fixed',
        right: 8,
        bottom: 6,
        zIndex: 99999,
        fontSize: 11,
        fontFamily: 'ui-monospace, monospace',
        color: 'rgba(0,0,0,0.35)',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      build {info.short}
    </div>
  );
}
